export default () => ({
  token: localStorage.getItem('utkn') || '',
})
